import React, { useState } from "react";
import { Link } from "react-router-dom";
import blogPosts from "../data/blogPosts";

const categories = ["All", ...new Set(blogPosts.map((p) => p.category))];

const BlogListPage = () => {
  const [active, setActive] = useState("All");

  const filtered =
    active === "All"
      ? blogPosts
      : blogPosts.filter((p) => p.category === active);

  return (
    <>
      {/* ===== BLOG HEADER ===== */}
      <section className="hero" style={{ padding: "140px 0 60px" }}>
        <div className="container">
          <p className="section-label">Blog</p>
          <h1>Insights &amp; Technical Writing</h1>
          <p className="hero-sub">
            Practical perspectives on building AI-powered products, SaaS
            development, and emerging technology.
          </p>
        </div>
      </section>

      {/* ===== BLOG LISTING ===== */}
      <section className="blog-section" style={{ paddingTop: "60px" }}>
        <div className="container">
          <div className="blog-categories">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                className={`blog-category-btn${active === cat ? " active" : ""}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="blog-preview">
            {filtered.map((post) => (
              <div className="blog-card" key={post.slug}>
                <span className="blog-tag">{post.tag}</span>
                <h3>
                  {post.published ? (
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  ) : (
                    <span style={{ color: "var(--white)" }}>{post.title}</span>
                  )}
                </h3>
                <p>{post.description}</p>
                <span className="blog-date">
                  {post.date}
                  {post.readTime ? ` \u00B7 ${post.readTime}` : ""}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogListPage;
